import _defineProperty from "/Users/martin/DEV/DFN_VEOMED-dfn/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _container2, _container3, _container4;
// src/components/switch.ts
import { switchAnatomy as parts } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers, defineStyle } from "@chakra-ui/styled-system";
import { calc, cssVar } from "@chakra-ui/theme-tools";
var _createMultiStyleConf = createMultiStyleConfigHelpers(parts.keys),
  defineMultiStyleConfig = _createMultiStyleConf.defineMultiStyleConfig,
  definePartsStyle = _createMultiStyleConf.definePartsStyle;
var $width = cssVar("switch-track-width");
var $height = cssVar("switch-track-height");
var $diff = cssVar("switch-track-diff");
var diffValue = calc.subtract($width, $height);
var $translateX = cssVar("switch-thumb-x");
var $bg = cssVar("switch-bg");
var baseStyleTrack = defineStyle(function (props) {
  var _checked, _ref;
  var c = props.colorScheme;
  return _ref = {
    borderRadius: "full",
    p: "0.5",
    width: [$width.reference],
    height: [$height.reference],
    transitionProperty: "common",
    transitionDuration: "fast"
  }, _defineProperty(_ref, $bg.variable, "colors.gray.300"), _defineProperty(_ref, "_dark", _defineProperty({}, $bg.variable, "colors.whiteAlpha.400")), _defineProperty(_ref, "_focusVisible", {
    boxShadow: "outline"
  }), _defineProperty(_ref, "_disabled", {
    opacity: 0.4,
    cursor: "not-allowed"
  }), _defineProperty(_ref, "_checked", (_checked = {}, _defineProperty(_checked, $bg.variable, "colors.".concat(c, ".500")), _defineProperty(_checked, "_dark", _defineProperty({}, $bg.variable, "colors.".concat(c, ".200"))), _checked)), _defineProperty(_ref, "bg", $bg.reference), _ref;
});
var baseStyleThumb = defineStyle({
  bg: "white",
  transitionProperty: "transform",
  transitionDuration: "normal",
  borderRadius: "inherit",
  width: [$height.reference],
  height: [$height.reference],
  _checked: {
    transform: "translateX(".concat($translateX.reference, ")")
  }
});
var baseStyle = definePartsStyle(function (props) {
  var _container;
  return {
    container: (_container = {}, _defineProperty(_container, $diff.variable, diffValue), _defineProperty(_container, $translateX.variable, $diff.reference), _defineProperty(_container, "_rtl", _defineProperty({}, $translateX.variable, calc($diff).negate().toString())), _container),
    track: baseStyleTrack(props),
    thumb: baseStyleThumb
  };
});
var sizes = {
  sm: definePartsStyle({
    container: (_container2 = {}, _defineProperty(_container2, $width.variable, "1.375rem"), _defineProperty(_container2, $height.variable, "sizes.3"), _container2)
  }),
  md: definePartsStyle({
    container: (_container3 = {}, _defineProperty(_container3, $width.variable, "1.875rem"), _defineProperty(_container3, $height.variable, "sizes.4"), _container3)
  }),
  lg: definePartsStyle({
    container: (_container4 = {}, _defineProperty(_container4, $width.variable, "2.875rem"), _defineProperty(_container4, $height.variable, "sizes.6"), _container4)
  })
};
var switchTheme = defineMultiStyleConfig({
  baseStyle: baseStyle,
  sizes: sizes,
  defaultProps: {
    size: "md",
    colorScheme: "blue"
  }
});
export { switchTheme };